import React from 'react';

const ExportFileIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="490"
    height="490"
    viewBox="0 0 24 24">
    <path fill="#293840" fillRule="evenodd" d="M11.742 0H3c-.552 0-1 .448-1 1v22c0 .552.448 1 1 1h18c.552 0 1-.448 1-1V11.26l-1.69 1.651v9.4H3.69V1.69l6.33.03L11.743 0zm3.933.03L14.48 1.222l4.045 4.041-.072.173h-3.068c-4.563 0-8.275 3.705-8.275 8.26 0 1.76.667 3.396 1.745 4.844l.144.189 1.326-1.048-.128-.167c-.74-.999-1.237-2.09-1.364-3.24l-.024-.288-.008-.29c0-3.545 2.826-6.443 6.348-6.568l.236-.004h3.159l.071.173-4.135 4.13 1.195 1.195 6.304-6.297L15.675.03z"/>
  </svg>
);

export default ExportFileIcon;
